import React, { useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'

interface ILineInputProps {
  defaultValue?: string
  placeholder?: string
  maxLength?: number
  isRequired?: boolean
  onChange: (value: string) => void
  onEntered?: (value: string) => void
  style?: React.CSSProperties
}

const LineInput: React.FC<ILineInputProps> = ({
  defaultValue,
  placeholder,
  maxLength,
  isRequired,
  onChange,
  onEntered,
  style,
}) => {
  const [value, setValue] = useState<string>(defaultValue || '')

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value)
      setValue(event.target.value)
    },
    [onChange]
  )

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (onEntered && event.key === 'Enter') onEntered(value)
    },
    [onEntered, value]
  )

  const handleBlur = useCallback(() => {
    if (onEntered) onEntered(value)
  }, [onEntered, value])

  return (
    <Form.Control
      value={value}
      type='text'
      placeholder={placeholder}
      maxLength={maxLength}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      style={style}
      className={isRequired ? (!value ? 'is-invalid' : 'is-valid') : ''}
    />
  )
}
export default LineInput
